/* eslint-disable */

import { useTranslation } from 'react-i18next';
import { Modal, ModalBackground } from '../../../assets/styles/Modal';
import { Dispatch, SetStateAction } from 'react';
import { IModal } from 'customTypes';
import DOMPurify from 'dompurify';
import styled from 'styled-components';

const PreviewStyle = styled.div`
  overflow-y: auto;

  strong {
    font-weight: 600;
  }

  table {
    width: 100%;
  }

  .table {
    display: table;
    margin: 0.9em auto;
    max-width: 700px;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    // height: 100%;

    .sub {
      table {
        width: auto;
      }
    }
  }

  .table table {
    overflow: hidden;
  }

  .table table td,
  .table table th {
    min-width: 2em;
    padding: 0.4em;
  }

  .table td,
  .table th {
    overflow-wrap: break-word;
    position: relative;
  }
`;
interface IProps {
  setOpenModal: Dispatch<SetStateAction<IModal>>;
  htmlSource: string | null;
}

const HtmlPreviewModal = ({ setOpenModal, htmlSource }: IProps) => {
  const { t } = useTranslation();
  const onClickClose = () => {
    setOpenModal((prev) => ({ ...prev, status: false }));
  };

  return (
    <ModalBackground onClick={onClickClose} role='presentation'>
      <Modal>
        <div
          className='modal raw-html'
          role='presentation'
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className='inputForm-head'>
            <div className='modalHeaderTitle'>{t('에디터 미리보기')}</div>
            <div className='closeBtn' onClick={onClickClose} role='presentation'>
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>
          <PreviewStyle>
            <div className='inputForm-body'>{htmlSource !== null && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlSource) }} />}</div>
          </PreviewStyle>
        </div>
      </Modal>
    </ModalBackground>
  );
};

export default HtmlPreviewModal;
